import React, { Component } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'translations';
import { Field } from 'redux-form';
import { Layout, Flex } from 'app/components/base/Layout';
import TransitionInput from 'app/components/base/TransitionInput';
import {
  TRAVELER_FIRST_NAME_FIELD_NAME,
  TRAVELER_LAST_NAME_FIELD_NAME,
  TRAVELER_EMAIL_FIELD_NAME
} from 'app/constants';

import style from './style.css';


const messages = {
  travelerSectionLabel: { id: 'BOOK_TRIP.CONTACT_INFO.TRAVELER_SECTION_LABEL' },
  travelerFirstName: { id: 'BOOK_TRIP.CONTACT_INFO.TRAVELER_FIRST_NAME' },
  travelerLastName: { id: 'BOOK_TRIP.CONTACT_INFO.TRAVELER_LAST_NAME' },
  travelerPhoneNumber: { id: 'BOOK_TRIP.CONTACT_INFO.TRAVELER_PHONE_NUMBER' },
  travelerBooking: { id: 'BOOK_TRIP.CONTACT_INFO.TRAVELER_BOOKING' },
  travelerEmail: { id: 'BOOK_TRIP.CONTACT_INFO.TRAVELER_EMAIL' },
  travelerClose: { id: 'CLOSE_THIS' }
};

const fieldSize = {
  '> mobile': 50,
  'mobile': 100
};

class TravelerData extends Component {
  renderTravelerFields = (index, isLast) => {
    const {
      onClickClose,
      extraPaxRequired
    } = this.props;
    return (
      <Layout className={style.layout}>
        <Flex size="100" className={classnames(style.field, style.label)}>
          <FormattedMessage {...messages.travelerSectionLabel} />
          {' '}
          {index + 2}
        </Flex>
        <Flex size={fieldSize} className={classnames(style.field, style['field--left'])}>
          <Field
            compact
            component={TransitionInput}
            name={`${TRAVELER_FIRST_NAME_FIELD_NAME}-${index}`}
            type="text"
            placeholder={<FormattedMessage {...messages.travelerFirstName} />}
            upwards
          />
        </Flex>
        <Flex size={fieldSize} className={style.field}>
          <Field
            compact
            component={TransitionInput}
            name={`${TRAVELER_LAST_NAME_FIELD_NAME}-${index}`}
            type="text"
            placeholder={<FormattedMessage {...messages.travelerLastName} />}
            upwards
          />
        </Flex>
        <Flex size={fieldSize} className={classnames(style.field, style['field--left'])}>
          <Field
            compact
            component={TransitionInput}
            name={`${TRAVELER_EMAIL_FIELD_NAME}-${index}`}
            type="email"
            placeholder={<FormattedMessage {...messages.travelerEmail} />}
            upwards
          />
        </Flex>
        {!isLast || extraPaxRequired ? null : (
          <Flex size={fieldSize} className={classnames(style.field, style.closeContainer)}>
            <span className={style.close}>
              <FormattedMessage {...messages.travelerBooking} />
              {' '}
              <span className={style.close__link} onClick={onClickClose}>
                <FormattedMessage {...messages.travelerClose} />
              </span>
            </span>
          </Flex>
        )}
      </Layout>
    );
  }

  render() {
    const {
      className,
      passengersCount
    } = this.props;
    const extraPaxCount = passengersCount - 1; // first traveler is a main traveler
    return (
      <Layout className={classnames(style.container, className)}>
        {Array(extraPaxCount).fill().map((_, index, arr) => (
          this.renderTravelerFields(index, index === arr.length - 1))
        )}
      </Layout>
    );
  }
}

// TODO: move to Flow types
// TravelerData.propTypes = {
//   className: PropTypes.string,
//   onClickClose: PropTypes.func,
//   formName: PropTypes.string.isRequired,
//   extraPaxRequired: PropTypes.bool,
//   passengersCount: PropTypes.bool
// };

export default TravelerData;
